import React, { Component } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { connect } from 'react-redux';
import { showMessage, showError, emailRead } from '../../actions/uiActions';
import Loading from '../Loading';
import InboxApi from '../../api/inbox';
import PaginatedTable from '../PaginatedTable';
import Email from '../Email';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Cancel from '@mui/icons-material/Cancel';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import AppBar from '@mui/material/AppBar';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import Checkbox from '@mui/material/Checkbox';
import { Archive } from '@mui/icons-material';
import { Tooltip } from '@mui/material';
import Formatter from '../../utils/Formatter';
class UserInbox extends Component {
  state = {
    support_messages: [],
    support_loading: true,
    support_count: 0,
    support_page: 0,
    support_sort: 'desc',
    support_unreadCount: 0,
    outbox_messages: [],
    outbox_loading: true,
    outbox_count: 0,
    outbox_page: 0,
    outbox_sort: 'desc',
    outbox_unreadCount: 0,
    borrower_messages: [],
    borrower_loading: true,
    borrower_count: 0,
    borrower_page: 0,
    borrower_sort: 'desc',
    borrower_unreadCount: 0,
    none_messages: [],
    none_loading: true,
    none_count: 0,
    none_page: 0,
    none_sort: 'desc',
    none_unreadCount: 0,
    currentTab: 0,
    message: null,
    searching: false,
    search: '',
    archive: [],
    archiving: false
  };
  archive = () => {
    if (this.state.archive.length > 0) {
      this.setState(
        {
          archiving: true
        },
        () =>
          InboxApi.archiveMail(this.state.archive)
            .then(
              success => {
                this.setState(
                  {
                    archiving: false,
                    archive: []
                  },
                  () => {
                    this.load('support', this.state.support_page);
                    this.load('borrower', this.state.borrower_page);
                    this.load('none', this.state.none_page);
                    this.load('outbox', this.state.outbox_page);
                    this.props.showMessage(
                      'The messages have been archived successfully.'
                    );
                  }
                );
              },
              error =>
                this.setState(
                  {
                    archiving: false
                  },
                  this.props.showError
                )
            )
            .catch(error =>
              this.setState(
                {
                  archiving: false
                },
                this.props.showError
              )
            )
      );
    }
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    this.search();
  }
  search = (searching = false) => {
    this.setState({ searching: searching && this.state.search != '' }, () => {
      this.load('support', 0);
      this.load('borrower', 0);
      this.load('none', 0);
      this.load('outbox', 0);
    });
  };
  load = (action, page = 0) => {
    InboxApi.load(
      this.props.id,
      action,
      page,
      this.state[`${action}_sort`],
      this.state.search
    )
      .then(
        result => {
          this.setState({
            [`${action}_loading`]: false,
            [`${action}_messages`]: result.messages,
            [`${action}_page`]: result.page,
            [`${action}_pages`]: result.pages,
            [`${action}_count`]: result.count,
            [`${action}_unreadCount`]: result.unreadCount
          });
        },
        error => {
          this.setState({ [`${action}_loading`]: false }, this.props.showError);
        }
      )
      .catch(error => {
        this.setState({ [`${action}_loading`]: false }, this.props.showError);
      });
  };
  renderInbox = action => {
    const getMessageColumns = message => {
      let columns = [
        {
          properties: {
            key: `${message._id}-0`
          },
          value: (
            <Checkbox
              disabled={this.state.archiving}
              onClick={e => e.stopPropagation()}
              checked={this.state.archive.includes(message._id)}
              onChange={e => {
                e.stopPropagation();
                if (e.target.checked) {
                  this.setState({
                    archive: [...this.state.archive, message._id]
                  });
                } else {
                  this.setState({
                    archive: this.state.archive.filter(id => id !== message._id)
                  });
                }
              }}
              value="secondary"
            />
          )
        },
        {
          properties: {
            key: `${message._id}-1`
          },
          value: message.date
        },
        {
          properties: {
            key: `${message._id}-3`
          },
          value: message.outbox
            ? Formatter.printMaxCharacters(message.to, 50)
            : Formatter.printMaxCharacters(message.from, 50)
        },
        {
          properties: {
            key: `${message._id}-4`
          },
          value: Formatter.printMaxCharacters(message.subject, 70)
        }
      ];
      if (action === 'none') {
        return columns.slice(1);
      }
      return columns;
    };
    let columns = [
      {
        name: (
          <Checkbox
            disabled={this.state.archiving}
            checked={
              !this.state[`${action}_messages`].find(
                message => !this.state.archive.find(id => id === message._id)
              )
            }
            onChange={e => {
              if (e.target.checked) {
                this.setState({
                  archive: [
                    ...this.state.archive,
                    ...this.state[`${action}_messages`].map(
                      message => message._id
                    )
                  ]
                });
              } else {
                this.setState({
                  archive: this.state.archive.filter(
                    m =>
                      !this.state[`${action}_messages`].find(
                        message => message._id === m
                      )
                  )
                });
              }
            }}
            value="primary"
          />
        ),
        properties: {
          key: 0,
          className: 'width5pct'
        }
      },
      {
        name: 'Date',
        properties: {
          key: 1,
          className: 'width10pct clickable'
        },
        sortable: true,
        asc: this.state[`${action}_sort`] === 'asc',
        onClick: () =>
          this.setState(
            {
              [`${action}_sort`]:
                this.state[`${action}_sort`] === 'asc' ? 'desc' : 'asc'
            },
            () => this.load(action, this.state[`${action}_page`])
          )
      },
      {
        name: action === 'outbox' ? 'To' : 'From',
        properties: {
          key: 3,
          className: 'width30pct'
        }
      },
      {
        name: 'Subject',
        properties: {
          key: 5,
          className: 'width50pct'
        }
      }
    ];
    if (action === 'none') {
      columns = columns.slice(1);
    }
    return (
      <div className="col-12">
        <Paper>
          <PaginatedTable
            goToPage={page => this.load(action, page)}
            count={parseInt(this.state[`${action}_count`].toString())}
            page={parseInt(this.state[`${action}_page`].toString())}
            loading={this.state[`${action}_loading`]}
            rows={this.state[`${action}_messages`].map(message => {
              return {
                properties: {
                  onClick: () => this.setState({ message }),
                  key: message._id,
                  className: `clickable ${!message.read ? 'unread' : ''}`
                },
                columns: getMessageColumns(message)
              };
            })}
            emptyMessage="No unread messages"
            columns={columns}
          />
        </Paper>
        <div className="line-break"></div>
      </div>
    );
  };

  getUserInbox() {
    return this.props.account.ppjEmail || this.props.id
  }

  render() {
    return this.state.message ? (
      <Email
        onRead={id => {
          let action = 'borrower';
          if (this.state.currentTab == 1) action = 'support';
          else if (this.state.currentTab == 2) action = 'outbox';
          else if (this.state.currentTab == 3) action = 'none';
          const messageWasUnread = this.state[`${action}_messages`].find(
            msg => msg._id == id && !msg.read
          );
          this.setState(
            {
              [`${action}_messages`]: this.state[`${action}_messages`].map(
                message => {
                  if (message._id == id) message.read = true;
                  return message;
                }
              ),
              [`${action}_unreadCount`]:
                this.state[`${action}_unreadCount`] - (messageWasUnread ? 1 : 0)
            },
            this.props.messageRead
          );
        }}
        id={this.props.id}
        message={this.state.message}
        onClose={() => this.setState({ message: null })}
      />
    ) : (
      <div className="padding animated fadeIn">
          {
            <>
              <div className="alert alert-info">
                The user must activate email forwarding to the email address{' '}
                <a href={`mailto:${this.getUserInbox()}@mail.peoplejoy.com`}>
                  <b>{`${this.getUserInbox()}@mail.peoplejoy.com`}</b>
                </a>{' '}
                in order to receive emails in this inbox.
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="row">
                    <div className="col-6">
                      <Paper style={{ display: 'flex' }} elevation={1}>
                        <InputBase
                          onKeyDown={e => {
                            if (e.keyCode == 13) this.search(true);
                          }}
                          disabled={this.state.searching}
                          value={this.state.search}
                          onChange={e =>
                            this.setState({ search: e.target.value })
                          }
                          placeholder="Find email..."
                          style={{ width: '90%', paddingLeft: '20px' }}
                        />
                        {this.state.searching && (
                          <IconButton
                            onClick={() =>
                              this.setState(
                                { search: '', searching: false },
                                () => this.search()
                              )
                            }
                            aria-label="Clear"
                          >
                            <Cancel />
                          </IconButton>
                        )}
                        <Divider
                          style={{
                            width: 1,
                            height: 34,
                            margin: 4
                          }}
                        />
                        <IconButton
                          onClick={() => this.search(true)}
                          aria-label="Search"
                        >
                          <SearchIcon />
                        </IconButton>
                      </Paper>
                    </div>
                    <div className="col-6 text-right">
                      {this.state.archive.length > 0 && (
                        <Tooltip title="Archive selected Emails">
                          <IconButton
                            onClick={this.archive}
                            disabled={this.state.archiving}
                          >
                            <Archive />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="line-break"></div>
              <Paper className="with-padding">
                <AppBar position="static" color="default">
                  <Tabs
                    value={this.state.currentTab}
                    onChange={(e, newValue) => this.setState({ currentTab: newValue })
                    }
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                  >
                    <Tab label={'Emails from PeopleJoy'} />
                    <Tab
                      label={
                        this.state.support_unreadCount > 0 ? (
                          <Badge
                            className="little-chip"
                            color="secondary"
                            badgeContent={this.state.support_unreadCount}
                          >
                            Emails from Servicers
                          </Badge>
                        ) : (
                          <span>Emails from Servicers</span>
                        )
                      }
                    />
                    <Tab label={'Emails Sent to PeopleJoy'} />
                    <Tab label={'Archived Emails'} />
                  </Tabs>
                </AppBar>
                {this.state.currentTab === 0 && this.renderInbox('borrower')}
                {this.state.currentTab === 1 && this.renderInbox('support')}
                {this.state.currentTab === 2 && this.renderInbox('outbox')}
                {this.state.currentTab === 3 && this.renderInbox('none')}
              </Paper>
            </>
          }
      </div>
    );
  }
}
export default connect(null, { showError, showMessage, emailRead })(UserInbox);
